import { ApiAction } from 'redux-upgrader'

export const GET_FRONT_PAGE = new ApiAction('GET_FRONT_PAGE')
